import dayjs from 'dayjs';
import { DateFormats } from '@/constants/dates';

export const formatDate = (date: string, format: DateFormats = DateFormats.DEFAULT) => dayjs(date).format(format);
